import { IonAccordion, IonAccordionGroup, IonButton, IonButtons, IonCard,IonCardHeader, IonCardSubtitle, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonModal, IonNavLink, IonNote, IonPage, IonRow, IonSpinner, IonText, IonTitle, IonToolbar, useIonAlert} from "@ionic/react";
import React, { useEffect,useState } from "react";
import { useTranslation } from "react-i18next";
import AppHeader from "../../components/AppHeader/AppHeader";
import { useGiftCardSendCreateMutation, useTopupSendMutation } from "../../services/api/ebioro/ebioro";
import { useAccountDetailsQuery } from "../../services/api/stellar";
import { useAppSelector } from "../../services/redux/hook";
import { TopUpPriceObject, Asset, TopUpCreateRequestParameters, TopUpSendRequestParameters, WalletInfoState, TopUpProvider} from "../../types/types";
import './GiftCard.css';
import * as Sentry from '@sentry/react';
import * as stellarSdk from '@stellar/stellar-sdk';
import * as stellarTxBuilder from '../../services/stellar/TransactionBuilder';
import * as sep7 from '../../services/stellar/sep7';
import { arrowBackOutline } from "ionicons/icons";
import PaymentProcessing from "../payment-processing/PaymentProcessing";

const GiftCardReviewPage: React.FC = () => {


    const nav = document.querySelector("ion-nav");

    const { t, i18n } = useTranslation();
    const [description, setDescription] = useState<any[]>([]);
    const language = useAppSelector((state) => state.language);
    const [isSpinner, setIsSpinner] = useState(false);
    const supportedAssets: Asset[] = useAppSelector((state) => state.supportedAssets.supportedAssets);
    const [createGiftCardTransaction, result] = useGiftCardSendCreateMutation();
    const [sendGiftCardTransaction, sendTopResult] = useTopupSendMutation();

    const selectedProvider:TopUpProvider = useAppSelector((state)=>state.selectedGiftCardProvider);
    const giftCardsPricing: TopUpPriceObject = useAppSelector((state) => state.giftCardsPricing);

    const [present] = useIonAlert();

    const presentErrorAlert = (message: any) => {

        setIsSpinner(false);
        present({
            header: 'Error',
            message: `${message}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    const supportedTopUpAsset = supportedAssets.filter((asset) => {

        return (asset.topups_enabled)
    })

    const [topupAsset, setTopUpAsset] = useState<Asset>(supportedTopUpAsset[0]);

    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);
    const { data: accountDetails } = useAccountDetailsQuery(walletInfo.account_key);

    const assetBalance = accountDetails?.details.balances[topupAsset.identifier] ? accountDetails?.details.balances[topupAsset.identifier].available.toNumber() : 0;

    const [totalToPay, setTotalToPay] = useState<number>(0);


    useEffect(() => {

        const init = async () => {

            let description = []

            description = giftCardsPricing.Product.descriptions.filter((element: any) => {

                return (element.language_code === language)
            })


            if (!description.length) {

                description = giftCardsPricing.Product.descriptions.filter((element: any) => {

                    return (element.language_code === 'en')
                })
            }

            setDescription(description);

            const toPay = (giftCardsPricing?.UsdcDisplayPrice as number) + (giftCardsPricing?.UsdcDisplayCustomerFee as number)

            setTotalToPay(toPay);
        }

        init();

    }, [selectedProvider,giftCardsPricing])

   
    const sendGiftCardTransfer = async () => {

        setIsSpinner(true);

        const params: TopUpCreateRequestParameters = {

            sku_code: giftCardsPricing.Product?.sku_code as string,
            send_value: giftCardsPricing?.Price.SendValue as number,
            send_currency_iso: giftCardsPricing?.Price.SendCurrencyIso as string,

            amount_in: (giftCardsPricing?.UsdcDisplayPrice as number) + (giftCardsPricing?.UsdcDisplayCustomerFee as number),
            fee_value: giftCardsPricing?.UsdcDisplayCustomerFee as number,
            asset_code: topupAsset.code,
            asset_issuer: topupAsset.identifier.split(":")[1] ? topupAsset.identifier.split(":")[1] : undefined,
            account_number: giftCardsPricing?.Product?.uat_number as string, // the api will decide if sending to test or production environment

        }

        try {

            const response = await createGiftCardTransaction(params).unwrap();

            const destination_address = response.withdraw_anchor_account;
            const destination_amount = totalToPay.toFixed(2);
            const destination_asset = topupAsset.code;
            let destination_asset_issuer = undefined;

            if (topupAsset.identifier != 'native') {
                destination_asset_issuer = topupAsset.identifier.split(":")[1]
            }

            let stellarTx: stellarSdk.Transaction<stellarSdk.Memo<stellarSdk.MemoType>, stellarSdk.Operation[]>;

            const [error, transaction] = await stellarTxBuilder.createPayment(
                destination_address,
                walletInfo.account_key as string,
                walletInfo.device_private_key as string, destination_amount, destination_asset, destination_asset_issuer);

            stellarTx = transaction as stellarSdk.Transaction<stellarSdk.Memo<stellarSdk.MemoType>, stellarSdk.Operation[]>;

            const uri = createSep7URI(stellarTx);

            const sendTopUpData: TopUpSendRequestParameters = {
                uri: uri?.toString() as string,
                asset_code: destination_asset,
                account: walletInfo.account_key as string,
                id: response.id
            }

            const sendTopResponse = await sendGiftCardTransaction(sendTopUpData).unwrap();
            const stellarTxId = sendTopResponse.stellar_transaction_id as string;
            setIsSpinner(false);
            nav?.push(() =><PaymentProcessing transactionId={stellarTxId}/>);

        } catch (error: any) {

            Sentry.captureException(error);
            presentErrorAlert(t('application.uncaught.ERROR'));
            return

        }
    }

    const createSep7URI = (stellarTx: stellarSdk.Transaction<stellarSdk.Memo<stellarSdk.MemoType>, stellarSdk.Operation[]>) => {

        if (walletInfo) {

            return sep7.createSep7URI(stellarTx, walletInfo.account_key as string/*, message*/);

        }

        return null

    }

    return (
        <IonPage>

            <IonHeader className="ion-no-border">

            <IonToolbar style={{ marginTop: "0%" }}>
                <IonNavLink routerDirection={'back'}>
                    <IonButtons slot='start'>
                        <IonButton color={'primary'} >
                            <IonIcon slot='start' icon={arrowBackOutline} />
                        </IonButton>
                    </IonButtons>
                </IonNavLink>

                <IonTitle> {t('giftcard_review.page.HEADER')}</IonTitle>
                    
                </IonToolbar>

        

            </IonHeader>

            <IonContent>

                <IonGrid className="ion-padding">
                    <IonRow>

                        <IonCol>

                            <IonItem lines="none" className="giftCardItem">

                                <h5  className="ion-text-wrap">
                                    {t('giftcard_review.page.SENDING-LABEL')}
                                </h5>
                                {
                                    (giftCardsPricing?.Product.maximum.SendValue === giftCardsPricing?.Product.minimum.SendValue) ?

                                        <h5 slot="end" className="ion-text-wrap">
                                            {`${giftCardsPricing?.Price.ReceiveValueExcludingTax} ${giftCardsPricing?.Price.ReceiveCurrencyIso} `}
                                        </h5> :
                                        <h5 className="ion-text-wrap" slot="end">

                                            <b>{description.length ? description[0].display_text : ""}</b>
                                        </h5>

                                }

                            </IonItem>

                        </IonCol>


                    </IonRow>
                    <IonRow>
                        <IonCol style={{ margin: "auto" }}>
                            <IonItem lines="none" className="giftCardItem">

                                <h5 className="ion-text-wrap" slot="start" >
                                    {t('giftcard_review.page.PROVIDER-LABEL')}
                                </h5>


                            </IonItem>
                        </IonCol>
                        <IonCol >

                            <IonCard>
                                <IonImg src={selectedProvider?.logo_url} />

                                <IonCardHeader>
                                    <IonCardSubtitle>{selectedProvider?.name}</IonCardSubtitle>
                                </IonCardHeader>

                            </IonCard>

                        </IonCol>
                    </IonRow>

                    {/* <IonRow>
                        <IonCol>
                            <IonItem lines="none" className="giftCardItem">
                                <h5>{t('giftcard_review.page.SUMMARY-LABEL')}</h5>
                            </IonItem>
                        </IonCol>
                    </IonRow> */}

                    <IonRow>
                        <IonCol>
                            

                                <IonAccordionGroup expand="inset" className="giftCard_review_accordion_group" value={"first"}>

                                    <IonAccordion value="first">
                                        <IonItem slot="header" lines='none' color={'primary'}>
                                            <IonLabel>
                                                <b>
                                                {t('giftcard_review.page.PAY-LABEL')} {(totalToPay).toFixed(2)} {`${topupAsset.code}`}
                                                </b>
                                            </IonLabel>
                                           
                                        </IonItem>
                                        <div className="ion-padding" slot="content" style={{ padding: "0px" }}>
                                            <hr style={{ margin: "0px" }} />
                                            <IonItem lines="none" >

                                                <IonLabel slot="start" className="ion-text-wrap">
                                                    {t('giftcard_review.page.SUBTOTAL-LABEL')}
                                                </IonLabel>

                                                <IonLabel slot="end" className="ion-text-wrap">
                                                    {(giftCardsPricing?.UsdcDisplayPrice.toFixed(2))} {`${topupAsset.code}`}
                                                </IonLabel>

                                            </IonItem>
                                            <IonItem lines="none">

                                                <IonLabel slot="start" className="ion-text-wrap">
                                                    {t('giftcard_review.page.FEE-LABEL')}
                                                </IonLabel>

                                                <IonLabel slot="end" className="ion-text-wrap">
                                                    {(giftCardsPricing?.UsdcDisplayCustomerFee.toFixed(2))} {`${topupAsset.code}`}
                                                </IonLabel>

                                            </IonItem>

                                            <IonItem lines="none" >
                                                <IonLabel slot="start" className="ion-text-wrap">
                                                    {t('giftcard_review.page.TOTAL-LABEL')}
                                                </IonLabel>
                                                <IonLabel slot="end" className="ion-text-wrap">
                                                    {totalToPay.toFixed(2)} {`${topupAsset.code}`}
                                                </IonLabel>

                                            </IonItem>
                                        </div>
                                    </IonAccordion>

                                </IonAccordionGroup>

                           
                        </IonCol>
                    </IonRow>
                
                </IonGrid>

               
            </IonContent>

            <IonFooter className="ion-no-border" >
                <IonToolbar>
                    <IonButton
                        type="submit"
                        color={'primary'}
                        onClick={() => sendGiftCardTransfer()}
                        expand="block"
                        id="pageFooterButton"
                        disabled={assetBalance < parseFloat((totalToPay).toFixed(2))}>
                        {
                            isSpinner ? (<IonSpinner className="BUTTON-SPINNER"></IonSpinner>)
                                :
                                assetBalance < parseFloat((totalToPay).toFixed(2)) ?
                                    t('send.page.NOT-ENOUGH-FUNDS') : t('giftcard_review.page.SEND.BTN-LABEL') + ` ${totalToPay.toFixed(2)} ${topupAsset.code}`
                        }
                    </IonButton>
                </IonToolbar>
            </IonFooter>

        </IonPage>
    )
}

export default React.memo(GiftCardReviewPage);